export default {
  showSwitchClass: (state) => {
    return (state.index.switch ==  true) ? 'switch' : '';
  }
}